import {RequestState} from "../../requestState";
import vue from "vue";
import {
  CASE_SERVICE_LOG_FETCH_BY_CASE,
  CASE_SERVICE_LOG_FETCH_BY_CASE_SUCCESS,
  CASE_SERVICE_LOG_FETCH_BY_CASE_FAILED
} from './available'

export default {
  [CASE_SERVICE_LOG_FETCH_BY_CASE](state, {caseId}) {
    vue.set(state.caseServiceLogs, caseId, {})
    vue.set(state.caseServiceLogs[caseId], 'requestState', RequestState.Loading)
  },
  [CASE_SERVICE_LOG_FETCH_BY_CASE_SUCCESS](state, {caseId, response}) {
    vue.set(state.caseServiceLogs[caseId], 'requestState', RequestState.Success)
    vue.set(state.caseServiceLogs[caseId], 'response', response)
  },
  [CASE_SERVICE_LOG_FETCH_BY_CASE_FAILED](state, {caseId}) {
    vue.set(state.caseServiceLogs[caseId], 'requestState', RequestState.Failed)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/case-service-log.js